import {
  defineComponent,
  getCurrentInstance,
  reactive,
  watch
} from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import './index.scss'
import _ from 'lodash'
import { getTopicOptions, changeOptionValue } from '../../util'
import { SCALE_MAX_SCORE_TYPE, SCORE_NUM_TYPE, SCORE_TYPE } from '../../config'
import { useSelector } from '@/utils/bhooks'
import i18n from '@/locales'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import BarScore from '@/pages/Survey/components/BarScore'
import StarScore from '@/pages/Survey/components/StarScore'
import FaceScore from '@/pages/Survey/components/FaceScore'
import { Message } from '@gcommon/gcommon-ui'
import CommonTetxEdit from '@/components/CommonTetxEdit'
import moment from 'moment'

const MatrixScaleEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const { surveyDetail } = useSelector(({ surveyDetail }) => ({
      surveyDetail
    }))
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    const instance = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    const isAllowEdit = () => {
      let res: boolean
      res = surveyDetail.surveyConfigNoDraftState?.surveyContent?.topics?.some(
        (item) => {
          return item.id == state.editItem.id
        }
      )
      return res
    }

    const changeOptionsRewrite = (value, options, isChild = 0) => {
      changeOptionValue(value, options, isChild)
    }

    const updateValue = (value, index) => {
      state.editItem.matrixValue[index].value = value
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }
    const getTrueValue = (matrixTopicsItem) => {
      let value: any = null
      props.item.matrixValue?.forEach((item) => {
        if (item.subTopicId === matrixTopicsItem.bizId) {
          value = item.value
        }
      })
      return value
    }

    const addMatrixSubtopics = (index) => {
      const subtopics = {
        bizId: '',
        customizeOption: 0,
        customizeOptionValue: null,
        id: '',
        matrixTopics: null,
        maxScore: 10,
        orderNum: 1,
        parentId: '',
        topicName: '',
        topicSetting: null,
        topicType: 18,
        key: new Date().getTime()
      }
      state.editItem.matrixTopics.splice(index + 1, 0, subtopics)
    }

    const deleteMatrixSubtopics = (index) => {
      if (state.editItem.matrixTopics.length < 3) {
        Message({
          message: tran('survy.matrixTips'),
          type: 'warning'
        })
      } else {
        state.editItem.matrixTopics.splice(index, 1)
      }
    }

    return () => {
      //子题列表
      const matrixTopicStr = getTopicOptions(
        state.editItem.matrixTopics,
        'topicName'
      )
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item topic-edit-content-title">
            {/* <div class='topic-edit-content-item-title'>{tran('survy.matrixlbquestionName')}:</div>
          <RichUtil onchangeValue={value => state.editItem.topicName = value} placeholder={tran('survy.plctopicname')} value={state.editItem.topicName}></RichUtil> */}
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.matrixlbquestionName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          <div class="matrix-nps-topic-content-right">
            <div class="matrix-nps-topic-content-right-item-title">
              <span>{state.editItem.topicSetting.minScoreDesc}</span>
              <span style={{ flex: 1 }}></span>
              <span>{state.editItem.topicSetting.maxScoreDesc}</span>
              {
                /* 根据后端条件判断要不要渲染 */
                !!state.editItem?.topicSetting.customizeOption && (
                  <div class="cust-title">
                    {state.editItem?.topicSetting.customizeOptionValue}
                  </div>
                )
              }
            </div>
            {state.editItem.matrixTopics.map((sitem, index) => {
              return (
                <div
                  class="matrix-nps-topic-content-right-item"
                  key={`${sitem.bizId ? sitem.bizId : sitem.key}`}>
                  <div class="sub-title">
                    <CommonTetxEdit
                      needDynamicEvent
                      initialData={sitem.topicName}
                      placeholder={tran('survy.entersonName')}
                      handleUpdate={(value, index) => {
                        sitem.topicName = value
                      }}
                    />
                  </div>
                  <div class="operate-icon">
                    <i
                      class="el-icon-circle-plus-outline el-icon-common-class"
                      onClick={() => {
                        addMatrixSubtopics(index)
                      }}></i>
                    <i
                      class="el-icon-delete el-icon-common-class"
                      onClick={() => {
                        deleteMatrixSubtopics(index)
                      }}></i>
                  </div>
                  {!state.editItem.topicSetting.scoreStyle && (
                    <div class="sub-score">
                      <BarScore
                        value={
                          Number(getTrueValue(sitem)) || getTrueValue(sitem)
                        }
                        minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                        maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={state.editItem.topicSetting.maxScore}
                        showTitle={false}
                        topicSetting={state.editItem.topicSetting}></BarScore>
                    </div>
                  )}
                  {state.editItem.topicSetting.scoreStyle === 1 && (
                    <div class="sub-score">
                      <StarScore
                        value={
                          Number(getTrueValue(sitem)) || getTrueValue(sitem)
                        }
                        minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                        maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={state.editItem.topicSetting.maxScore}
                        showTitle={false}
                        topicSetting={state.editItem.topicSetting}></StarScore>
                    </div>
                  )}

                  {state.editItem.topicSetting.scoreStyle === 2 && (
                    <div class="sub-score">
                      <FaceScore
                        value={
                          Number(getTrueValue(sitem)) || getTrueValue(sitem)
                        }
                        minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                        maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                        onupdateValue={(value) => updateValue(value, index)}
                        maxScore={state.editItem.topicSetting.maxScore}
                        showTitle={false}
                        topicSetting={state.editItem.topicSetting}></FaceScore>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
          <div class="topic-edit-content-item">
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.matrixlbelend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              maxScore={state.editItem.topicSetting.maxScore}
              minScoreDesc={state.editItem.topicSetting.minScoreDesc}
              maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
              scoreStyle={state.editItem.topicSetting.scoreStyle}
              isAllowEdit={isAllowEdit()}
              customizeOption={
                state.editItem.topicSetting.customizeOption ? true : false
              }
              customizeOptionValue={
                state.editItem.topicSetting.customizeOptionValue
              }
              onChangeMaxScore={(value) => {
                state.editItem.topicSetting.maxScore = value
              }}
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeMinScoreDesc={(value) => {
                state.editItem.topicSetting.minScoreDesc = value
              }}
              onChangeMaxScoreDesc={(value) => {
                state.editItem.topicSetting.maxScoreDesc = value
              }}
              onChangeScoreStyle={(value) => {
                state.editItem.topicSetting.scoreStyle = value
              }}
              onChangeCustomizeOption={(value) => {
                state.editItem.topicSetting.customizeOption = value
              }}
              onChangeCustomizeOptionValue={(value) => {
                state.editItem.topicSetting.customizeOptionValue = value
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default MatrixScaleEdit
